import React, { useCallback, useEffect, useRef, useState } from "react";

import ColorViewModel from "./ColorViewModel";

import { Button } from "primereact/button";
import { Column, ColumnEditorOptions, ColumnEvent } from "primereact/column";
import { DataTable, DataTableFilterMeta } from "primereact/datatable";
import { InputText } from "primereact/inputtext";

import { FilterMatchMode } from "primereact/api";

import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import './Color.css';

import { confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { classNames } from "primereact/utils";
import { Controller, useForm } from "react-hook-form";
import { useToast } from "../../../../Shared/hook/useToast";
import { Color } from "../../Domain/Model/Color";

interface ColumnMeta {
  field: string;
  header: string;
  editable: boolean;
}

export const ColorView = ()=> {
  const [filters, setFilters] = useState<DataTableFilterMeta>({ global: { value: null, matchMode: FilterMatchMode.CONTAINS }});
  // const toast = useRef<Toast>(null);
  const { showSuccess, showError, showWarn, showInfo } = useToast();
  const defaultValues = {
    name: '',
};
  const [visible, setVisible] = useState<boolean>(false);
  const {
    getColors,
    createColor,
    removeColor,
    updateColor,
    onChangeColor,
    colors,
  } = ColorViewModel();

  const columns: ColumnMeta[] = [
      // {field: 'id', header: 'Id', editable: false},
      {field: 'name', header: 'Nombre', editable: true},
      { field: 'options', header: 'Opciones', editable: false },
  ];
  
      useEffect(() => {
        getColors();
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);


    //    const show = ( severity: any, summary: any, detail: any,) => {
    //     // @ts-ignore
    //     toast.current.show({ severity: `${severity}`, summary: `${summary}`, detail: `${detail}`});
    // };

      const accept = async (id: string) => {
        
        let deleted = await removeColor(id);
        console.log(deleted);
        if(deleted){
          showSuccess('Confirmada','has aceptado');
          await getColors();
        }      
    }

    const reject = () => {
       showWarn('Rechazada', 'has rechazado');
    }


    const onSubmit = (
        data: {
            name: string,
        }
      ) => {
          data.name && showSuccess("Se registro", data.name);
          let datos =  data;
          if(datos){
            const colorData: Color = {
              name: data.name,
              id: ""
            };
            createColor(colorData);
          }
          getColors();
          console.log(datos);
          reset();
    };

    const {
        control,
        formState: { errors },
        handleSubmit,
        reset
    } = useForm({ defaultValues });

    const getFormErrorMessage = (name: string) => {
        // @ts-ignore
        return errors[name] ? <small className="p-error">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>;
    };


      const isUpdatingRef = useRef(false);
      const onCellEditComplete = useCallback( async(e: ColumnEvent) => {
          // Guard contra doble ejecución simultánea
          if (isUpdatingRef.current) return;
          isUpdatingRef.current = true;
          let { rowData, newValue, field, originalEvent: event } = e;

          if (newValue === null || newValue === undefined || newValue === "") {
            event.preventDefault();
            isUpdatingRef.current = false;
            return;
          }

          
         if (rowData[field] === newValue) {
            event.preventDefault();
            isUpdatingRef.current = false;
            return;
          }
      
         
          const updatedRow = { ...rowData, [field]: newValue };

          await updateColorData(updatedRow,  field, event);
          isUpdatingRef.current = false;
      }, []);

      const updateColorData = async (rowData: any, field: string, e: any)=>{
            try {
            const data = await updateColor(rowData);

            if (data) {
              showSuccess("Se actualizo", "Se ha actualizado con éxito!");
              getColors();
            }
          } catch (error) {
            console.error("Error al actualizar:", error);
            showError("Error", "No se pudo actualizar");
            e.preventDefault();
          }
      }

      const cellEditor = (options: ColumnEditorOptions) => {
        // if (options.field === 'state') return noTextEditor();
        // else return textEditor(options);
        return textEditor(options);
    };

    const textEditor = (options: ColumnEditorOptions) => {
        return (
            <InputText 
                type="text" 
                value={options.value || ''} // Asegúrate de que options.value no sea nulo o indefinido
                onChange={(e) => options.editorCallback!(e.target.value)} 
            />
        );
    };

      const onGlobalFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
          const value = event.target.value;
          let _filters = { ...filters };
          // @ts-ignore
          _filters['global'].value = value.toString() || '';

          setFilters(_filters);
          // setGlobalFilterValue(value);
      };

      const header = ()=>{
        // @ts-ignore
       const value = filters['global'] ? filters['global'].value : '';

       return (
           <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between">
               <h4 className="m-0">
                   <button type="button" className="btn btn-dark" onClick={() => setVisible(true)}>
                    <FontAwesomeIcon icon={icon({name: 'plus'})} /> 
                   Nuevo color</button>

               </h4>
               <span className="p-input-icon-left">
                   <i className="pi pi-search" />
                   <InputText type="search" value={value || ''} onChange={(e) => 
                       onGlobalFilterChange(e)} placeholder="Buscar..." />
               </span>
           </div>
      )};

      const btnOptions = (id: string, name: string) => {

        return(
            <>
                <div className="d-flex">
                    <button onClick={()=>confirmDelete(id)} className="btn btn-dark"><FontAwesomeIcon icon={icon({name: 'trash'})} /></button>
                </div>
            </>
        );
    }

    const confirmDelete = (id: string) => {

      confirmDialog({
          message: '¿Quieres eliminar este registro?',
          header: 'Eliminar confirmación',
          icon: 'pi pi-info-circle',
          acceptClassName: 'p-button-danger',
          acceptLabel: 'Si',
          rejectLabel: 'No',
          accept: () => accept(id),
          reject
      });
  };

    // const RemoveColor =  async (id: string)  => {
    //   let deleted = await removeColor(id);

    //     //showDelete(name);
    //     if(deleted){
    //       console.log("RemoveColor");
           
           
    //     }
       

    // }

      const paginatorLeft = <Button type="button" icon="pi pi-refresh" text />;
      const paginatorRight = <Button type="button" icon="pi pi-download" text />;
    
    return (
        <>
          <div className="container-fluid">
            <div className="block-header">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 text-start">
                        <h2>Lista Colores</h2>
                        <ul className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a href="/home" className="text-danger"><FontAwesomeIcon icon={icon({name: 'home'})} /></a>
                            </li>
                            <li className="breadcrumb-item">Lista Colores</li>
                        </ul>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="d-flex flex-row-reverse">
                            <div className="page_action">
                                {/* <button type="button" className="btn btn-dark"><FontAwesomeIcon icon={icon({name: 'plus'})} /> Nuevo producto</button> */}
                            </div>
                            <div className="p-2 d-flex">
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className='title-report'>
                    Aquí puedes ver los últimos colores añadidos
                </div>
                {/* <InputSwitch  key={'index01254'} checked={checkedw} onChange={(e: InputSwitchChangeEvent) =>  setCheckedw(!checkedw)} /> */}
                
            </div>
            <div className='row'>
              <div className='col-lg-12'>
                {/* <Toast ref={toast} /> */}
                {/* <ConfirmDialog /> */}
                <DataTable value={colors!} lazy paginator rows={10} editMode="cell" rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{    minWidth: '50rem' }}
                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate="{first} to {last} of {totalRecords}" paginatorLeft={paginatorLeft} paginatorRight={paginatorRight}  
                        globalFilterFields={['id', 'name']} emptyMessage="No customers found." stateStorage="session"
                        header={header} filters={filters} onFilter={(e) => setFilters(e.filters)}>
                    {columns.map(({ field, header, editable  }) => {
                            return <Column key={field} field={field} header={header}
                            body={ 
                              field === 'options' ? (e)=> btnOptions(e.id, e.name) : null 
                            }
                            editor={editable ? (options) => cellEditor(options) : undefined} onCellEditComplete={onCellEditComplete} />
                    })}
                </DataTable>
                <Dialog header="Agregar Color" visible={visible} maximizable style={{ width: '400px' }} onHide={() => setVisible(false)}>
                      <form onSubmit={handleSubmit(onSubmit)} className="text-start">
                        {/* <Toast ref={toast} /> */}
                        <div className="d-flex flex-column gap-2 ">
                            <Controller
                                name="name"
                                control={control}
                                rules={{ required: 'Nombre es requerido.' }}
                                render={({ field, fieldState }) => (
                                <>
                                    <label htmlFor={field.name}>
                                        Nombre
                                    </label>
                                    <InputText  id={field.name} name={field.name} value={field.value}  onChange={(e) => field.onChange(e.target.value)} className={classNames({ 'p-invalid': fieldState.error })} />
                                    {getFormErrorMessage(field.name)}
                                </>
                            )}
                            />
                            <Button label="Guardar" type="submit" icon="pi pi-check" className={"btn btn-dark"} />
                        </div>
                        
                      </form>
                </Dialog>
               </div>
            </div>
          </div>
        </>
    );
}
